// extracted by mini-css-extract-plugin
export default {"table_container":"Table_table_container__agQuG","table_wrapper":"Table_table_wrapper__QCuGd","table_head":"Table_table_head__KlaQX","table_title":"Table_table_title__Pedix"};